enum EStatusConta {
  ATIVA = 'ATIVA',
  EM_ANALISE = 'EM_ANALISE',
  RECUSADA = 'RECUSADA',
  CONTA_NAO_NECESSARIA = 'CONTA_NAO_NECESSARIA',
}

export default EStatusConta
